// extracted by mini-css-extract-plugin
export default {"titleArea":"ExplanationTooltip_titleArea__W-AqW","textArea":"ExplanationTooltip_textArea__-nuJ4","container":"ExplanationTooltip_container__Xi8Cz"};